import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const NumberFieldContainer = styled.div<{ theme?: { token: GlobalToken } }>`
  position: relative;
  display: flex;
  align-items: center;
  width: 53px;
  flex-shrink: 0;
  margin-right: 12px;

  .compressor-number-input {
    width: 50px;
    border-color: ${({ theme }) => theme?.token?.colorBorder};

    &.error {
      border-color: ${({ theme }) => theme?.token?.colorError};
    }

    &.ant-input-number {
      .ant-input-number-handler-wrap {
        display: none;
      }
    }
  }
`;
